import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Gift } from 'lucide-react';

const HeroSection = () => {
  const handlePurchase = () => {
    window.location.href = '/products/guide';
  };

  return (
    <section className="pt-28 pb-20 px-6">
      <div className="max-w-5xl mx-auto">
        {/* Branded Banner */}
        <div className="rounded-xl overflow-hidden shadow-2xl mb-12">
          <img 
            src="/images/spendless-banner.png" 
            alt="Spend Less. Live More." 
            className="w-full h-auto"
            data-testid="hero-banner-img"
          />
        </div>

        <div className="text-center">
          {/* Launch Banner */}
          <div className="inline-block bg-[#C17855] text-white px-6 py-2 rounded-full text-sm font-bold mb-6 animate-pulse">
            LAUNCH SPECIAL: 33% OFF + $99 in FREE Bonuses!
          </div>
          
          <p className="text-[#6B7A5C] text-sm uppercase tracking-wider mb-8">
            A 7-CHAPTER SYSTEM FOR INTENTIONAL LIVING
          </p>
          
          <h1 className="text-6xl md:text-8xl font-bold mb-8 leading-tight">
            <span className="text-[#2C1810]">Cut Your</span>
            <br />
            <span className="text-[#2C1810]">Expenses</span>
            <br />
            <span className="text-[#2C1810]">by </span>
            <span className="text-[#6B7A5C]">20-50%</span>
          </h1>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Button 
              onClick={handlePurchase}
              className="bg-[#C17855] hover:bg-[#B06745] text-white px-8 py-6 text-lg rounded-lg transition-all shadow-md hover:shadow-lg relative"
              data-testid="hero-cta-btn"
            >
              <span className="absolute -top-3 -right-3 bg-[#6B7A5C] text-white text-xs px-3 py-1 rounded-full font-bold animate-bounce">
                SAVE $5
              </span>
              Get the Guide + Bonuses — $9.99
            </Button>
            <Link to="/free-guide">
              <Button 
                variant="outline"
                className="border-2 border-[#6B7A5C] text-[#6B7A5C] hover:bg-[#6B7A5C] hover:text-white px-8 py-6 text-lg rounded-lg transition-all"
                data-testid="hero-free-guide-btn"
              >
                Free: 10 Ways to Spend Less
              </Button>
            </Link>
          </div>
          
          <p className="text-[#2C1810] text-sm font-semibold mb-4">
            <span className="font-bold">System, not tips.</span> Designed for people who want freedom, not deprivation.
          </p>
          
          <p className="text-[#C17855] text-xs mb-8">
            Launch price ends after first 100 sales - Regular price: $14.99
          </p>

          {/* Bonuses Quick List */}
          <div className="bg-[#EBE6D8] border-2 border-[#6B7A5C] border-dashed rounded-lg p-6 mb-8 max-w-2xl mx-auto">
            <div className="flex items-center justify-center gap-2 mb-3">
              <Gift className="w-5 h-5 text-[#6B7A5C]" />
              <p className="font-bold text-[#2C1810]">Includes $99 Worth of FREE Bonuses:</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-[#2C1810]">
              {['Printable Audit Checklists', 'Weekly Spending Planner', 'Climate-Specific Plant List', 'DIY Project Cheat Sheets', '90-Day Implementation Plan'].map((bonus, i) => (
                <div key={i} className={`flex items-center gap-2 ${i === 4 ? 'md:col-span-2 justify-center' : ''}`}>
                  <span className="text-[#6B7A5C] font-bold">&#10003;</span>
                  <span>{bonus}</span>
                </div>
              ))}
            </div>
          </div>
          
          <p className="text-[#5A5046] text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
            Not another list of frugal tips. SpendLess is a complete system — 7 chapters of permaculture thinking, DIY strategies, and smarter daily habits that permanently reduce what you spend.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
